<div class="top-nav">

  <button (click)="returnToSummary()" aria-label="Back" class="btn btn-back">
    <i class="fa fa-arrow-left"></i>
    <span> review management</span>
  </button>
  <div style="flex-grow: 1">

  </div>
  @if (cohort) {
    <div>{{ReviewView[reviewView] | caseSplit}} | Batch deadline: {{cohort.reviewDeadline | date:
    'dd/MM/yyyy'}}</div>
  }
</div>
<app-banner [info]="true" heading="Reviews in QA" subHeading="Reviews in quality assurance stage">

  <div class="toolbar-content">

    <button (click)="togglePanel('filter')" aria-label="Filter reviews" class="btn btn-back no-focus"
      [class.open]="panel==='filter'">
      <i class="fa fa-search"></i>
      <span>filter</span>
    </button>

  </div>

</app-banner>


<app-collapsible [trigger]="panel === 'filter'">
  <div class="dropdown-panel">
    <h4>
      <span>Filter</span>
      <button (click)="panel=undefined" class="btn-default btn-close"><i class="fa fa-close"></i></button>
    </h4>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group filter-param" [class.active]="filterParams.reviewer !== undefined">
          <div class="filter-header">

            <label>Reviewer</label>
            <button [class.active]="activeFilterParams.reviewer !== undefined" class="btn-clear-filter"
              (click)="clearFilter('reviewer')"><i class="fa fa-close"></i></button>
            </div>


            <mat-select class="form-control" [(ngModel)]="filterParams.reviewer" placeholder="Select a reviewer...">
              @for (reviewer of reviewers; track reviewer; let i = $index) {
                <mat-option [value]="reviewer.userId">
                {{ reviewer.name }}</mat-option>
              }
            </mat-select>

          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group filter-param" [class.active]="filterParams.reviewStage !== undefined">
            <div class="filter-header">
              <label>Stage</label>
              <button [class.active]="activeFilterParams.reviewStage !== undefined" class="btn-clear-filter"
                (click)="clearFilter('reviewStage')"><i class="fa fa-close"></i></button>
              </div>
              <mat-select name="reviewStage" class="form-control" placeholder="Select review stage..."
                [(ngModel)]="filterParams.reviewStage">
                @for (item of ReviewStage | keys; track item) {
                  <mat-option [value]="item.key">{{ item.value | caseSplit }}
                  </mat-option>
                }
              </mat-select>
            </div>

          </div>

          <div class="col-md-6">
            <div class="form-group filter-param" [class.active]="filterParams.finalAssessment !== undefined">
              <div class="filter-header">
                <label>Final assessment</label>
                <button [class.active]="activeFilterParams.finalAssessment !== undefined" class="btn-clear-filter"
                  (click)="clearFilter('finalAssessment')"><i class="fa fa-close"></i></button>
                </div>
                <mat-select name="finalAssessment" class="form-control" placeholder="Select final assessment indicator..."
                  [(ngModel)]="filterParams.finalAssessment">
                  @for (item of PerformanceIndicator | keys; track item) {
                    <mat-option [value]="item.key">{{ item.value | caseSplit }}
                    </mat-option>
                  }
                </mat-select>
              </div>

            </div>
            <div class="col-md-6">
              <div class="form-group filter-param" [class.active]="filterParams.qaManagerApproved !== undefined">
                <div class="filter-header">
                  <label>QA manager approved</label>
                  <button [class.active]="activeFilterParams.qaManagerApproved !== undefined" class="btn-clear-filter"
                    (click)="clearFilter('qaManagerApproved')"><i class="fa fa-close"></i></button>
                  </div>

                  <div style="overflow:hidden;">
                    <mat-radio-group style="white-space: nowrap" [(ngModel)]="filterParams.qaManagerApproved">
                      <mat-radio-button [value]="true">Approved</mat-radio-button>
                      <mat-radio-button [value]="false">Not approved</mat-radio-button>
                    </mat-radio-group>
                  </div>

                </div>

              </div>
              <div class="col-md-6">
                <div class="form-group filter-param" [class.active]="filterParams.qaApproved !== undefined">
                  <div class="filter-header">
                    <label>QA approved</label>
                    <button [class.active]="activeFilterParams.qaApproved !== undefined" class="btn-clear-filter"
                      (click)="clearFilter('qaApproved')"><i class="fa fa-close"></i></button>
                    </div>

                    <div style="overflow:hidden;">
                      <mat-radio-group style="white-space: nowrap" [(ngModel)]="filterParams.qaApproved">

                        <mat-radio-button [value]="true">Approved</mat-radio-button>
                        <mat-radio-button [value]="false">Not approved</mat-radio-button>
                      </mat-radio-group>
                    </div>

                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group filter-param" [class.active]="filterParams.excludedFromPublish !== undefined">
                    <div class="filter-header">
                      <label>Excluded from publish</label>
                      <button [class.active]="activeFilterParams.excludedFromPublish !== undefined" class="btn-clear-filter"
                        (click)="clearFilter('excludedFromPublish')"><i class="fa fa-close"></i></button>
                      </div>

                      <div style="overflow:hidden;">
                        <mat-radio-group style="white-space: nowrap" [(ngModel)]="filterParams.excludedFromPublish">
                          <mat-radio-button [value]="true">Excluded</mat-radio-button>
                          <mat-radio-button [value]="false">Not excluded</mat-radio-button>
                        </mat-radio-group>
                      </div>

                    </div>
                  </div>

                </div>


                <div class="row">
                  <div class="col-md-12">
                    <button [disabled]="!hasFilterParams || filterParamsAreActive || loading"
                    class="btn btn-primary btn-lg btn-block" (click)="load()">Apply filter</button>
                  </div>
                </div>



              </div>

            </app-collapsible>
            <app-collapsible [trigger]="hasActiveFilterParams && !loading">
              <div class="filter-param-info">
                <div style="flex-grow:1">
                  @for (item of activeFilterParamsInfo; track item) {
                    <div class="filter-param-info-item">{{ item.value }} <button
                      class="btn-clear-filter" (click)="clearFilter(item.key)"><i class="fa fa-close"></i></button></div>
                    }

                  </div>
                  <button class="btn btn-default btn-clear-all-filters" (click)="clearAllFilters()">Clear all</button>
                </div>
              </app-collapsible>
              <app-pager [datasource]="service.getCohortQa.bind(service)" (loaded)="onLoad($event)"></app-pager>

              @if (!loading) {
                <div class="content no-boxes fadein">
                  @if (data.length > 0) {
                    <div style="padding-bottom: 20px">
                      <table class="table">
                        <thead>
                          <tr>
                            <th style="width: 80px"> Title</th>
                            <th style="width:100px">Assigned to</th>
                            <th style="width:100px">Registrant</th>
                            <th style="width: 140px">Stage</th>
                            <th>Reviewers</th>
                            <th>Indicators</th>
                            <th>Updated</th>
                            <th>Final assessment</th>
                            <!---  <th>Remediation</th>-->
                            <th>QA Approved</th>
                            <th>QM Approved</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (row of data; track row) {
                            <tr [class.failed]="row.failedCoreCriteria">
                              <!---<td>
                              <span *ngIf="item !== assigningItem">{{ item.assignedAt | date: 'dd/MM/yyyy' }}</span>
                            </td>-->
                            <td class="clickable" (click)="openReview(row)">{{ row.title }}</td>
                            <td class="assigned-to" (click)="assigningItem = row; $event.stopPropagation()">
                              <app-review-assign [item]="row" (selected)="assigningItem = $event" [selecting]="row === assigningItem">
                              </app-review-assign>
                            </td>
                            <td class="clickable" (click)="openReview(row)"> @if (row.failedCoreCriteria) {
                              <i appTooltip="Core criteria not met"
                              class="fa fa-warning"></i>
                              }&nbsp;{{ row.registrationNumber }}
                            </td>
                            <td>
                              <span>{{ ReviewStage[row.reviewStage] | caseSplit }}</span>
                            </td>
                            <!--- <td>{{ row.dateAssigned }}</td> -->
                            <td style="width: 360px;">
                              <div style="display:flex; align-items: center">
                                <div [class.hidden]="editing.id === row.id" style="flex-grow:1"><span class="primary">{{
                                  row.leadReviewerName }}</span> | <span class="secondary">{{ row.secondaryReviewerName }}</span>
                                </div>
                                <button (click)="toggleEdit(row)" class="btn-edit">
                                  <i class="fa fa-pencil" [class.fa-pencil]="editing.id !== row.id"
                                  [class.fa-close]="editing.id === row.id"></i>
                                </button>
                              </div>
                              <app-collapsible [trigger]="editing.id === row.id">
                                @if (editing.id === row.id) {
                                  <app-change-reviewers [editing]="editing" [row]="row" (changed)="cancelEdit()"></app-change-reviewers>
                                }
                              </app-collapsible>
                            </td>
                            <td> <span class="primary">{{ PerformanceIndicator[row.leadReviewerIndicator] | caseSplit }} </span> |
                            <span class="secondary">{{ PerformanceIndicator[row.secondaryReviewerIndicator] | caseSplit }}</span>
                          </td>
                          <td> {{ row.lastUpdated | date: 'dd/MM/yyyy' }}</td>
                          <td>
                            <div class="performance-indicator {{PerformanceIndicator[row.finalAssessment]}}">
                              {{ PerformanceIndicator[row.finalAssessment] | caseSplit }}
                            </div>
                          </td>
                          <!---  <td> {{ row.inRemediationThisYear | friendlyBoolean }}</td>-->
                          <td>@if (row.qualityAssurerApproved) {
                            <i appTooltip="QA approved" class="fa fa-check"></i>
                          }
                        </td>
                        <td>@if (row.qualityAssuranceManagerApproved) {
                          <i appTooltip="QA Manager approved" class="fa fa-check"></i>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <div class="no-data">
              No reviews in this batch matching the given criteria.
            </div>
          }
        </div>
      }

